import { useCallback } from "react";

import { useNavigateWithParams } from "../../../router/hooks";
import { PATH } from "../../../router/path";
import { PAGE_PARAM } from "../../constants";

export const useHandleClickProduct = (): ((
	brand_menu_item_id: number,
	mode: PAGE_PARAM,
	cart_item_index: string
) => (e: React.SyntheticEvent) => void) => {
	const { navigateWithParams } = useNavigateWithParams();

	return useCallback(
		(brand_menu_item_id: number, mode: PAGE_PARAM = PAGE_PARAM.NEW, cart_item_index: string = "") =>
			(e: React.SyntheticEvent) => {
				e.stopPropagation();
				navigateWithParams(PATH.PRODUCT_DETAIL, {
					brand_menu_item_id: brand_menu_item_id.toString(),
					mode,
					cart_item_index,
				});
			},
		[navigateWithParams]
	);
};
